import keycloakAxios from '@/services/axios';
import {updateGroupInRedux} from '@/redux-store/slices/groups';
import {store} from '@/redux-store/store';
import {GroupFormData} from '@/types/group';

export const updateGroup = async (
  groupId: string,
  groupData: GroupFormData
) => {
  groupData._id = groupId;

  const response = await keycloakAxios.post(`group`, groupData);

  if (response.status >= 300) {
    throw new Error(
      `Error updating group: Invalid status code: ${response.status}`
    );
  }

  store.dispatch(updateGroupInRedux(response.data));

  return response.data;
};
